import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import About from "@/components/About";
import Sermons from "@/components/Sermons";
import Events from "@/components/Events";
import Event from "@/components/Event";
import Ministries from "@/components/Ministries";
import Resources from "@/components/Resources";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/sermons",
      name: "Sermons",
      component: Sermons
    },
    {
      path: "/events",
      name: "Events",
      component: Events
    },
    {
      path: "/events/:event_id",
      name: "Event",
      component: Event
    },
    {
      path: "/ministries",
      name: "Ministries",
      component: Ministries
    },
    {
      path: "/resources",
      name: "Resources",
      component: Resources
    }
  ],
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js